var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 132,
    viewBox: "0 0 131 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7691 20.5336L72.1573 21.9825L73.6062 21.5943L96.4309 15.4784C101.905 14.0118 107.603 17.2927 109.072 22.7768L114.494 43.0133L107.379 44.9198C98.0151 47.4288 92.5265 56.9352 95.0356 66.2993C97.5447 75.6633 107.051 81.1519 116.415 78.6428L123.53 76.7363L128.949 96.9603C130.416 102.434 127.135 108.132 121.651 109.601L101.414 115.024L99.5077 107.909C96.9987 98.5449 87.4923 93.0563 78.1282 95.5654C68.7628 98.0748 63.2886 107.579 65.7973 116.942L67.7037 124.056L47.4672 129.479C41.9936 130.945 36.2956 127.665 34.8261 122.18L28.7103 99.3557L28.3221 97.9068L26.8732 98.295L18.3094 100.59C11.1217 102.516 3.9906 98.3985 2.06466 91.2108C0.138715 84.0231 4.25587 76.8919 11.4436 74.966L20.0073 72.6713L21.4562 72.2831L21.068 70.8343L14.9525 48.0095C13.4859 42.5358 16.7668 36.8378 22.2509 35.3683L45.0756 29.2525L46.5245 28.8642L46.1362 27.4154L43.8416 18.8516C41.9151 11.6632 46.0298 4.52015 53.2297 2.59096C60.4174 0.665015 67.5485 4.78218 69.4744 11.9699L71.7691 20.5336Z",
    stroke: "#BBDEFF",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.eeeeb75df641f9bec9d94c853c70bc5f.svg";
export { ForwardRef as ReactComponent };